// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YxoFG40mFwICtLT_lI_p {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    padding: 0 8px;
}

.ZkiSjLagPlIeQD7JJ1Bv {
    font-weight: 500 !important;
    font-size: 16px !important;
    color: #333;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Shared/AvailabilityShared/CalendarHeader/CalendarMonthPicker/CalendarMonthPicker.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,WAAW;AACf","sourcesContent":[".wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 16px;\n    padding: 0 8px;\n}\n\n.monthYear {\n    font-weight: 500 !important;\n    font-size: 16px !important;\n    color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `YxoFG40mFwICtLT_lI_p`,
	"monthYear": `ZkiSjLagPlIeQD7JJ1Bv`
};
export default ___CSS_LOADER_EXPORT___;
